module.exports = __webpack_public_path__ + "img/drug-16.88cf8ac3.png";